import { render, staticRenderFns } from "./Seckill.vue?vue&type=template&id=248c8512&scoped=true&"
import script from "./Seckill.vue?vue&type=script&lang=js&"
export * from "./Seckill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c8512",
  null
  
)

export default component.exports